module.exports = __webpack_public_path__ + "static/media/team2.6f13e07e.png";